import Cookie from 'js-cookie';
import axiosInstance from '@/utils/axiosInstance';

function getGA4Cookies() {
  const analyticsCookies = [];

  const ga = Cookie.get('_ga');

  if (ga) {
    analyticsCookies.push({
      name: 'ga',
      value: ga,
    });
  }

  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

  if (!measurementId) {
    return analyticsCookies;
  }

  const [, secondPart] = measurementId.split('-');

  if (!secondPart) {
    return analyticsCookies;
  }

  const cookieValue = Cookie.get(`_ga_${secondPart}`);

  // Check cookie has a value before add it to the analytics list
  if (cookieValue) {
    analyticsCookies.push({
      name: `ga_${secondPart}`,
      value: cookieValue,
    });
  }

  return analyticsCookies;
}

export default async function postClientCookies() {
  const gaCookies = getGA4Cookies();

  if (gaCookies.length === 0) {
    return;
  }

  await axiosInstance.post('/client/cookies', gaCookies, {
    headers: {
      'Content-Type': 'application/vnd.analytics.v2+json',
    },
  });
}
